module.exports = __webpack_public_path__ + "static/img/function5.8b049781.png";